/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { PracticeStrictHttpResponse } from '../../practice-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientTreatmentQueueListItemModel } from '../../models/patient-treatment-queue-list-item-model';

export interface PatientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet$Params {
  clinicGroupId: string;
}

export function patientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet(http: HttpClient, rootUrl: string, params: PatientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet$Params, context?: HttpContext): Observable<PracticeStrictHttpResponse<Array<PatientTreatmentQueueListItemModel>>> {
  const rb = new RequestBuilder(rootUrl, patientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet.PATH, 'get');
  if (params) {
    rb.path('clinicGroupId', params.clinicGroupId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as PracticeStrictHttpResponse<Array<PatientTreatmentQueueListItemModel>>;
    })
  );
}

patientTreatmentQueueClinicGroupIdClinicTreatmentQueuesGet.PATH = '/PatientTreatmentQueue/{clinicGroupId}/ClinicTreatmentQueues';
